import { DestroyRef, Directive, HostListener, inject, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, NavigationStart, RouterEvent } from '@angular/router';
import { filter, tap, first } from 'rxjs/operators';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { isPlatformBrowser, LocationStrategy } from '@angular/common';


let BackBottomSheetId = 0;

// Pour avoir un comportement correct des classes héritée.
// sur la classe fille :
//   1. appeler ce constructeur parent => super(...)
//   2. executer la méthode ngOnInit => super.ngOnInit();

@Directive({
  host: {
    '(window:popstate)': 'dismissModal()'
  }
})
export class BackBottomSheet<T> implements OnInit, OnDestroy {

  private readonly _destroyRef = inject(DestroyRef);
  protected removeStateOnDestroy = false;
  private _stateReference = { backBottomSheetId: ++BackBottomSheetId };
  
  dismissModal() {
    this.removeDummyHistoryState();
    this.bottomSheetRef.dismiss(true);
  }

  constructor(
    protected bottomSheetRef: MatBottomSheetRef<T, boolean>,
    protected router: Router,
    @Inject(PLATFORM_ID) protected _platformId: object) {

    router.events.pipe(
      filter((event) => event instanceof NavigationStart),
      first(),
      tap(() => {
        this.removeDummyHistoryState();
        this.bottomSheetRef.dismiss(true);
      }),
      takeUntilDestroyed(this._destroyRef)
    ).subscribe();
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this._platformId)) {
      history.pushState(this._stateReference, document.getElementsByTagName('title')[0].innerHTML, window.location.href);
    }
  }

  ngOnDestroy(): void {
    this.removeDummyHistoryState();
  }

  private removeDummyHistoryState() {
    if (this.removeStateOnDestroy
      && isPlatformBrowser(this._platformId)
      && history.state.backBottomSheetId === this._stateReference.backBottomSheetId) {
      history.back();
    }
  }

}

